import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-263" data-mp="llmec9lhp1b7">
      <HeroSection data-id="element-264" data-mp="lnh01q4l4xgc" />
      <ProofSection data-id="element-265" data-mp="lnz4ha1eihzc" />
      <ProblemSection data-id="element-266" data-mp="2zj7058razv7b" />
      <SystemSection data-id="element-267" data-mp="2zjyk1mbjg4hr" />
      <ModulesSection data-id="element-268" data-mp="2zki4paskp6zh" />
      <BonusSection data-id="element-269" data-mp="2zh3z7tom4hnt" />
      <UrgencySection data-id="element-270" data-mp="33k90jswyidav" />
      <PricingSection data-id="element-271" data-mp="33jqslz0xman4" />
      <TestimonialsSection data-id="element-272" data-mp="33l1xy3a0zqgc" />
      <GuaranteeSection data-id="element-273" data-mp="33i60eg23b3sf" />
      <FAQSection data-id="element-274" data-mp="38j3hepbd5rsc" />
      <FinalCTA data-id="element-275" data-mp="38ikb65v2sru5" />
      <Footer data-id="element-276" data-mp="38i25kimix19k" />
      <PurchasePopup data-id="element-277" data-mp="38iajmduducmc" />
    </main>;
}